<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card :prepend-icon="mdiAccount" :title="formTitle">
      <v-form ref="form" @submit.prevent>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.version-number') + ' *'"
                v-model="editedItem.versionNumber"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.change-description')"
                v-model="editedItem.changeDescription"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-switch
                v-model="editedItem.isActive"
                :label="$t('admin.active')"
                color="#ffb500"
                hide-details
              ></v-switch>
            </v-col>

            <v-col cols="12" md="12" sm="12">
              <v-textarea
                :label="$t('admin.full-text') + ' *'"
                v-model="editedItem.fullText"
              ></v-textarea>
            </v-col>
          </v-row>

          <small class="text-caption text-medium-emphasis">
            {{ $t("require-fields") }}
          </small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            :text="$t('close')"
            variant="plain"
            @click="$emit('close')"
          ></v-btn>

          <v-btn
            color="#ffb500"
            type="submit"
            :text="$t('save')"
            variant="tonal"
            @click="save"
          ></v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiPencil, mdiAccount } from "@mdi/js";
import { mapState } from "vuex";

export default {
  name: "AddEditTermsAndConditions",
  props: ["modelDialog"],
  data() {
    return {
      mdiPencil,
      mdiAccount
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    ...mapState({
      editedId: (state) => state.termsAndConditions.editedId
    }),
    editedItem: {
      get() {
        return this.$store.state.termsAndConditions.editedItem;
      },
      set(value) {
        this.$store.commit("termsAndConditions/setEditedItem", value);
      }
    },
    formTitle() {
      return this.editedId === -1
        ? this.$t("admin.new-terms-and-conditions")
        : this.$t("admin.edit-terms-and-conditions");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      const valid = this.$refs.form.isValid;
      if (valid) {
        if (this.editedId === -1) {
          this.$store
            .dispatch("termsAndConditions/saveEditedItem")
            .then(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.success.address-create"),
                color: "success"
              });
              this.close();
            })
            .catch(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.address-create"),
                color: "error"
              });
              this.close();
            });
        } else {
          this.$store
            .dispatch("termsAndConditions/updateEditedItem")
            .then(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.success.address-update"),
                color: "success"
              });
              this.close();
            })
            .catch(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.address-update"),
                color: "error"
              });
              this.close();
            });
        }
      }
    }
  }
};
</script>
